'use strict';

/**
 * Add a molecule and align it horizontally
 * @returns {molecule}
 */

module.exports = function () {
  return function addMoleculeAndAlign(molecule) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$space = options.space,
        space = _options$space === undefined ? 2 : _options$space;

    var boundary = this.getBoundary();
    var addBoundary = molecule.getBoundary();

    var y = (boundary.minY + boundary.maxY) / 2 - (addBoundary.minY + addBoundary.maxY) / 2;

    molecule.translateCoords(boundary.maxX - addBoundary.minX + space, y);
    this.addMolecule(molecule);
    return this;
  };
};